module.exports = __webpack_public_path__ + "img/app.95d10b19.png";